/* eslint-disable */
export const ncrBarangays = [
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 287',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 288',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 289',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 290',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 291',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 292',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 292',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 293',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 294',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 295',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 296',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 297',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 298',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 299',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 300',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 301',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 302',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 303',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 304',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 305',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 310',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 311',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 312',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 313',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 314',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 315',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 316',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 317',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 318',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 319',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 320',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 321',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 322',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 323',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 324',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 325',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 326',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 326',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 327',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 328',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 329',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 330',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 331',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 332',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 333',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 334',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 335',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 336',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 337',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 338',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 339',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 340',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 341',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 342',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 343',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 344',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 345',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 346',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 347',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 348',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 349',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 350',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 351',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 352',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 353',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 354',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 355',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 356',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 357',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 358',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 359',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 360',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 361',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 362',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 363',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 364',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 365',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 366',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 367',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 368',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 369',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 370',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 371',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 372',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 373',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 374',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 375',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 376',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 377',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 378',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 379',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 380',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 381',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 382',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 1',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 10',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 100',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 101',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 102',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 103',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 104',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 105',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 106',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 107',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 108',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 109',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 11',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 110',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 111',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 112',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 113',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 114',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 115',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 116',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 117',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 118',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 119',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 12',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 120',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 121',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 122',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 123',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 124',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 125',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 126',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 127',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 128',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 129',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 13',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 130',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 131',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 132',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 133',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 134',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 135',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 136',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 137',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 138',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 139',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 14',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 140',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 141',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 142',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 143',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 144',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 145',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 146',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 147',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 148',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 149',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 15',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 150',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 151',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 152',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 153',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 154',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 155',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 156',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 157',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 158',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 159',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 16',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 160',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 161',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 162',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 163',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 164',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 165',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 166',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 167',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 168',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 169',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 17',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 170',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 171',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 171',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 172',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 173',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 174',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 175',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 176',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 177',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 178',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 179',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 18',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 180',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 181',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 182',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 183',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 184',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 185',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 186',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 187',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 188',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 19',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 2',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 20',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 21',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 22',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 23',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 24',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 25',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 26',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 27',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 28',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 29',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 3',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 30',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 30',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 31',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 32',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 33',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 34',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 35',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 36',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 37',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 38',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 39',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 4',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 40',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 41',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 42',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 43',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 44',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 45',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 46',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 47',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 48',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 49',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 5',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 50',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 51',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 52',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 53',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 54',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 55',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 56',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 57',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 58',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 59',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 6',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 60',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 61',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 62',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 63',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 64',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 65',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 66',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 67',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 68',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 69',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 7',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 70',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 71',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 72',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 73',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 74',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 75',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 76',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 77',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 78',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 79',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 8',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 80',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 81',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 82',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 83',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 84',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 85',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 86',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 87',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 88',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 89',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 9',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 90',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 91',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 92',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 93',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 94',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 95',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 96',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 97',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 98',
    },
    {
        CITY: 'CALOOCAN',
        BARANGAY: 'BARANGAY 99',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 659',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 659~A',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 659-A',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 660',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 660~A',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 660-A',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 661',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 663',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 663~A',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 663-A',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 664',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 666',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 667',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 668',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 669',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 670',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 670',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 654',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 655',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 656',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 657',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 658',
    },
    {
        CITY: 'LAS-PINAS',
        BARANGAY: 'ALMANZA DOS',
    },
    {
        CITY: 'LAS-PINAS',
        BARANGAY: 'ALMANZA UNO',
    },
    {
        CITY: 'LAS-PINAS',
        BARANGAY: 'B. F. INTERNATIONAL VILLAGE',
    },
    {
        CITY: 'LAS-PINAS',
        BARANGAY: 'DANIEL FAJARDO',
    },
    {
        CITY: 'LAS-PINAS',
        BARANGAY: 'ELIAS ALDANA',
    },
    {
        CITY: 'LAS-PINAS',
        BARANGAY: 'ILAYA',
    },
    {
        CITY: 'LAS-PINAS',
        BARANGAY: 'MANUYO DOS',
    },
    {
        CITY: 'LAS-PINAS',
        BARANGAY: 'MANUYO UNO',
    },
    {
        CITY: 'LAS-PINAS',
        BARANGAY: 'PAMPLONA DOS',
    },
    {
        CITY: 'LAS-PINAS',
        BARANGAY: 'PAMPLONA TRES',
    },
    {
        CITY: 'LAS-PINAS',
        BARANGAY: 'PAMPLONA UNO',
    },
    {
        CITY: 'LAS-PINAS',
        BARANGAY: 'PILAR',
    },
    {
        CITY: 'LAS-PINAS',
        BARANGAY: 'PULANG LUPA DOS',
    },
    {
        CITY: 'LAS-PINAS',
        BARANGAY: 'PULANG LUPA UNO',
    },
    {
        CITY: 'LAS-PINAS',
        BARANGAY: 'TALON DOS',
    },
    {
        CITY: 'LAS-PINAS',
        BARANGAY: 'TALON KUATRO',
    },
    {
        CITY: 'LAS-PINAS',
        BARANGAY: 'TALON SINGKO',
    },
    {
        CITY: 'LAS-PINAS',
        BARANGAY: 'TALON TRES',
    },
    {
        CITY: 'LAS-PINAS',
        BARANGAY: 'TALON UNO',
    },
    {
        CITY: 'LAS-PINAS',
        BARANGAY: 'ZAPOTE',
    },
    {
        CITY: 'MAKATI',
        BARANGAY: 'BANGKAL',
    },
    {
        CITY: 'MAKATI',
        BARANGAY: 'BEL~AIR',
    },
    {
        CITY: 'MAKATI',
        BARANGAY: 'BEL-AIR',
    },
    {
        CITY: 'MAKATI',
        BARANGAY: 'CARMONA',
    },
    {
        CITY: 'MAKATI',
        BARANGAY: 'CEMBO',
    },
    {
        CITY: 'MAKATI',
        BARANGAY: 'COMEMBO',
    },
    {
        CITY: 'MAKATI',
        BARANGAY: 'DASMARINAS',
    },
    {
        CITY: 'MAKATI',
        BARANGAY: 'EAST REMBO',
    },
    {
        CITY: 'MAKATI',
        BARANGAY: 'FORBES PARK',
    },
    {
        CITY: 'MAKATI',
        BARANGAY: 'GUADALUPE NUEVO',
    },
    {
        CITY: 'MAKATI',
        BARANGAY: 'GUADALUPE VIEJO',
    },
    {
        CITY: 'MAKATI',
        BARANGAY: 'KASILAWAN',
    },
    {
        CITY: 'MAKATI',
        BARANGAY: 'LA PAZ',
    },
    {
        CITY: 'MAKATI',
        BARANGAY: 'MAGALLANES',
    },
    {
        CITY: 'MAKATI',
        BARANGAY: 'OLYMPIA',
    },
    {
        CITY: 'MAKATI',
        BARANGAY: 'PALANAN',
    },
    {
        CITY: 'MAKATI',
        BARANGAY: 'PEMBO',
    },
    {
        CITY: 'MAKATI',
        BARANGAY: 'PINAGKAISAHAN',
    },
    {
        CITY: 'MAKATI',
        BARANGAY: 'PIO DEL PILAR',
    },
    {
        CITY: 'MAKATI',
        BARANGAY: 'PITOGO',
    },
    {
        CITY: 'MAKATI',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MAKATI',
        BARANGAY: 'POST PROPER NORTHSIDE',
    },
    {
        CITY: 'MAKATI',
        BARANGAY: 'POST PROPER NORTHSIDE',
    },
    {
        CITY: 'MAKATI',
        BARANGAY: 'POST PROPER SOUTHSIDE',
    },
    {
        CITY: 'MAKATI',
        BARANGAY: 'POST PROPER SOUTHSIDE',
    },
    {
        CITY: 'MAKATI',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'MAKATI',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'MAKATI',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'MAKATI',
        BARANGAY: 'SAN LORENZO',
    },
    {
        CITY: 'MAKATI',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'MAKATI',
        BARANGAY: 'SINGKAMAS',
    },
    {
        CITY: 'MAKATI',
        BARANGAY: 'SOUTH CEMBO',
    },
    {
        CITY: 'MAKATI',
        BARANGAY: 'TEJEROS',
    },
    {
        CITY: 'MAKATI',
        BARANGAY: 'URDANETA',
    },
    {
        CITY: 'MAKATI',
        BARANGAY: 'VALENZUELA',
    },
    {
        CITY: 'MAKATI',
        BARANGAY: 'WEST REMBO',
    },
    {
        CITY: 'MALABON',
        BARANGAY: 'ACACIA',
    },
    {
        CITY: 'MALABON',
        BARANGAY: 'BARITAN',
    },
    {
        CITY: 'MALABON',
        BARANGAY: 'BAYAN-BAYANAN',
    },
    {
        CITY: 'MALABON',
        BARANGAY: 'CATMON',
    },
    {
        CITY: 'MALABON',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'MALABON',
        BARANGAY: 'DAMPALIT',
    },
    {
        CITY: 'MALABON',
        BARANGAY: 'FLORES',
    },
    {
        CITY: 'MALABON',
        BARANGAY: 'HULONG DUHAT',
    },
    {
        CITY: 'MALABON',
        BARANGAY: 'IBABA',
    },
    {
        CITY: 'MALABON',
        BARANGAY: 'LONGOS',
    },
    {
        CITY: 'MALABON',
        BARANGAY: 'MAYSILO',
    },
    {
        CITY: 'MALABON',
        BARANGAY: 'MUZON',
    },
    {
        CITY: 'MALABON',
        BARANGAY: 'NIUGAN',
    },
    {
        CITY: 'MALABON',
        BARANGAY: 'PANGHULO',
    },
    {
        CITY: 'MALABON',
        BARANGAY: 'POTRERO',
    },
    {
        CITY: 'MALABON',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'MALABON',
        BARANGAY: 'SANTOLAN',
    },
    {
        CITY: 'MALABON',
        BARANGAY: 'TANONG',
    },
    {
        CITY: 'MALABON',
        BARANGAY: 'TANONG (POB.)',
    },
    {
        CITY: 'MALABON',
        BARANGAY: 'TINAJEROS',
    },
    {
        CITY: 'MALABON',
        BARANGAY: 'TONSUYA',
    },
    {
        CITY: 'MALABON',
        BARANGAY: 'TUGATOG',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 688',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 689',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 690',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 691',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 691',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 692',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 693',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 694',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 695',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 696',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 697',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 698',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 699',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 700',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 701',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 702',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 703',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 704',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 705',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 706',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 707',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 708',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 709',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 709',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 709',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 710',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 711',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 712',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 713',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 714',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 715',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 716',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 717',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 718',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 719',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 720',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 721',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 722',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 723',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 724',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 724',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 725',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 726',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 727',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 728',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 729',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 730',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 731',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 732',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 733',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 734',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 735',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 736',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 737',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 738',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 739',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 740',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 741',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 742',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 743',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 744',
    },
    {
        CITY: 'MANDALUYONG',
        BARANGAY: 'ADDITION HILLS',
    },
    {
        CITY: 'MANDALUYONG',
        BARANGAY: 'ADDITION HILLS',
    },
    {
        CITY: 'MANDALUYONG',
        BARANGAY: 'BAGONG SILANG',
    },
    {
        CITY: 'MANDALUYONG',
        BARANGAY: 'BARANGKA DRIVE',
    },
    {
        CITY: 'MANDALUYONG',
        BARANGAY: 'BARANGKA IBABA',
    },
    {
        CITY: 'MANDALUYONG',
        BARANGAY: 'BARANGKA ILAYA',
    },
    {
        CITY: 'MANDALUYONG',
        BARANGAY: 'BARANGKA ITAAS',
    },
    {
        CITY: 'MANDALUYONG',
        BARANGAY: 'BUAYANG BATO',
    },
    {
        CITY: 'MANDALUYONG',
        BARANGAY: 'BUROL',
    },
    {
        CITY: 'MANDALUYONG',
        BARANGAY: 'DAANG BAKAL',
    },
    {
        CITY: 'MANDALUYONG',
        BARANGAY: 'HAGDANG BATO ITAAS',
    },
    {
        CITY: 'MANDALUYONG',
        BARANGAY: 'HAGDANG BATO LIBIS',
    },
    {
        CITY: 'MANDALUYONG',
        BARANGAY: 'HARAPIN ANG BUKAS',
    },
    {
        CITY: 'MANDALUYONG',
        BARANGAY: 'HIGHWAY HILLS',
    },
    {
        CITY: 'MANDALUYONG',
        BARANGAY: 'HIGHWAY HILLS',
    },
    {
        CITY: 'MANDALUYONG',
        BARANGAY: 'HULO',
    },
    {
        CITY: 'MANDALUYONG',
        BARANGAY: 'MABINI~J. RIZAL',
    },
    {
        CITY: 'MANDALUYONG',
        BARANGAY: 'MABINI-J. RIZAL',
    },
    {
        CITY: 'MANDALUYONG',
        BARANGAY: 'MALAMIG',
    },
    {
        CITY: 'MANDALUYONG',
        BARANGAY: 'MAUWAY',
    },
    {
        CITY: 'MANDALUYONG',
        BARANGAY: 'NAMAYAN',
    },
    {
        CITY: 'MANDALUYONG',
        BARANGAY: 'NEW ZANIGA',
    },
    {
        CITY: 'MANDALUYONG',
        BARANGAY: 'OLD ZANIGA',
    },
    {
        CITY: 'MANDALUYONG',
        BARANGAY: 'PAG~ASA',
    },
    {
        CITY: 'MANDALUYONG',
        BARANGAY: 'PAG-ASA',
    },
    {
        CITY: 'MANDALUYONG',
        BARANGAY: 'PLAINVIEW',
    },
    {
        CITY: 'MANDALUYONG',
        BARANGAY: 'PLAINVIEW',
    },
    {
        CITY: 'MANDALUYONG',
        BARANGAY: 'PLEASANT HILLS',
    },
    {
        CITY: 'MANDALUYONG',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MANDALUYONG',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'MANDALUYONG',
        BARANGAY: 'VERGARA',
    },
    {
        CITY: 'MANDALUYONG',
        BARANGAY: 'WACK~WACK GREENHILLS',
    },
    {
        CITY: 'MANDALUYONG',
        BARANGAY: 'WACK-WACK GREENHILLS',
    },
    {
        CITY: 'MARIKINA',
        BARANGAY: 'BARANGKA',
    },
    {
        CITY: 'MARIKINA',
        BARANGAY: 'CALUMPANG',
    },
    {
        CITY: 'MARIKINA',
        BARANGAY: 'CONCEPCION DOS',
    },
    {
        CITY: 'MARIKINA',
        BARANGAY: 'CONCEPCION UNO',
    },
    {
        CITY: 'MARIKINA',
        BARANGAY: 'FORTUNE',
    },
    {
        CITY: 'MARIKINA',
        BARANGAY: 'INDUSTRIAL VALLEY',
    },
    {
        CITY: 'MARIKINA',
        BARANGAY: 'JESUS DE LA PENA',
    },
    {
        CITY: 'MARIKINA',
        BARANGAY: 'MALANDAY',
    },
    {
        CITY: 'MARIKINA',
        BARANGAY: 'MARIKINA HEIGHTS (CONCEPCION)',
    },
    {
        CITY: 'MARIKINA',
        BARANGAY: 'NANGKA',
    },
    {
        CITY: 'MARIKINA',
        BARANGAY: 'PARANG',
    },
    {
        CITY: 'MARIKINA',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'MARIKINA',
        BARANGAY: 'SANTA ELENA',
    },
    {
        CITY: 'MARIKINA',
        BARANGAY: 'SANTA ELENA (POB.)',
    },
    {
        CITY: 'MARIKINA',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'MARIKINA',
        BARANGAY: 'STO NINO',
    },
    {
        CITY: 'MARIKINA',
        BARANGAY: 'TANONG',
    },
    {
        CITY: 'MARIKINA',
        BARANGAY: 'TUMANA',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 395',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 396',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 397',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 398',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 399',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 400',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 401',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 402',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 403',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 404',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 405',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 406',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 407',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 408',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 409',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 410',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 411',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 412',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 413',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 414',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 415',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 416',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 417',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 418',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 419',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 420',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 421',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 422',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 423',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 424',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 425',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 426',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 427',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 428',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 429',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 430',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 431',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 432',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 433',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 434',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 435',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 436',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 437',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 438',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 439',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 440',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 441',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 442',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 443',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 444',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 445',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 446',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 447',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 448',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 449',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 450',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 451',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 452',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 453',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 454',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 455',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 456',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 456',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 457',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 458',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 459',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 460',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 461',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 462',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 463',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 464',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 465',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 466',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 467',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 468',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 469',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 470',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 471',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 472',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 472',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 473',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 474',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 475',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 476',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 477',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 478',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 479',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 480',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 481',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 482',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 483',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 484',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 485',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 486',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 487',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 488',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 489',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 490',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 491',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 492',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 493',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 494',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 495',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 496',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 497',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 498',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 499',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 500',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 501',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 502',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 503',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 504',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 505',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 506',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 507',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 508',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 509',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 510',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 511',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 512',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 513',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 514',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 515',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 516',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 517',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 518',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 519',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 520',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 521',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 522',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 523',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 524',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 525',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 526',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 527',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 528',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 529',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 530',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 531',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 532',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 533',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 534',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 535',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 536',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 537',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 538',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 539',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 540',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 541',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 542',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 543',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 544',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 545',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 546',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 547',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 548',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 549',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 550',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 551',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 552',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 553',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 554',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 555',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 556',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 557',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 558',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 559',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 560',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 561',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 562',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 563',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 564',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 565',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 566',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 567',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 568',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 569',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 570',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 571',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 572',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 573',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 574',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 575',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 576',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 577',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 578',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 579',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 580',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 581',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 582',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 583',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 584',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 585',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 586',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 587',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 587~A',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 587-A',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 588',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 589',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 590',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 591',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 592',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 593',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 594',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 595',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 596',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 597',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 598',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 599',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 600',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 601',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 602',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 603',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 604',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 605',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 606',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 607',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 608',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 609',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 610',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 611',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 612',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 613',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 614',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 615',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 616',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 617',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 618',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 619',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 620',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 621',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 622',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 623',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 624',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 625',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 626',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 627',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 628',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 629',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 630',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 631',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 632',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 633',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 634',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 635',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 636',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'ADDITION HILLS',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'BALONG~BATO',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'BALONG-BATO',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'BALONG-BATO',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'BATIS',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'CORAZON DE JESUS',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'MANILANO',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'GREENHILLS',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'HALO~HALO (ST. JOSEPH)',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'HALO-HALO (ST. JOSEPH)',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'ISABELITA',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'KABAYANAN',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'LITTLE BAGUIO',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'MAYTUNAS',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'ONSE',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'PASADENA',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'PEDRO CRUZ',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'PROGRESO',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'RIVERA',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'SALAPAN',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'SAN PERFECTO',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'SANTA LUCIA',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'TIBAGAN',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'WEST CRAME',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 637',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 638',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 639',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 640',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 641',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 642',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 643',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 644',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 645',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 646',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 647',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 648',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 268',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 269',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 270',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 271',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 272',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 273',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 274',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 275',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 276',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 281',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 282',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 283',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 284',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 285',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 286',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 745',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 746',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 747',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 748',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 749',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 750',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 751',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 752',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 753',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 754',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 755',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 756',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 757',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 758',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 759',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 760',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 761',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 762',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 763',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 764',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 765',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 766',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 767',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 768',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 769',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 770',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 771',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 772',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 773',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 774',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 775',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 776',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 777',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 778',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 779',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 780',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 781',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 782',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 783',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 784',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 785',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 786',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 787',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 788',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 789',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 790',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 791',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 792',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 793',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 794',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 795',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 796',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 797',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 798',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 799',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 800',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 801',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 802',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 803',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 804',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 805',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 806',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 807',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 808',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 818~A',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 818-A',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 866',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 873',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 874',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 875',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 876',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 877',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 878',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 879',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 880',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 881',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 882',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 883',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 884',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 885',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 886',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 887',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 888',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 889',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 890',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 890',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 891',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 892',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 893',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 894',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 895',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 896',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 897',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 898',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 899',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 900',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 901',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 902',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 903',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 904',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 905',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 587',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 587~A',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 587-A',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 588',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 589',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 590',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 591',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 592',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 593',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 594',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 595',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 596',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 597',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 598',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 599',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 600',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 601',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 602',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 603',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 604',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 605',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 606',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 607',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 608',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 609',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 610',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 611',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 612',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 613',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 614',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 615',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 616',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 617',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 618',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 619',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 620',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 621',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 622',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 623',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 624',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 625',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 626',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 627',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 628',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 628',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 628',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 629',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 630',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 631',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 632',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 633',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 634',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 635',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 636',
    },
    {
        CITY: 'MUNTINLUPA',
        BARANGAY: 'ALABANG',
    },
    {
        CITY: 'MUNTINLUPA',
        BARANGAY: 'AYALA ALABANG',
    },
    {
        CITY: 'MUNTINLUPA',
        BARANGAY: 'BAYANAN',
    },
    {
        CITY: 'MUNTINLUPA',
        BARANGAY: 'BULI',
    },
    {
        CITY: 'MUNTINLUPA',
        BARANGAY: 'CUPANG',
    },
    {
        CITY: 'MUNTINLUPA',
        BARANGAY: 'CUPANG',
    },
    {
        CITY: 'MUNTINLUPA',
        BARANGAY: 'NEW ALABANG VILLAGE',
    },
    {
        CITY: 'MUNTINLUPA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MUNTINLUPA',
        BARANGAY: 'PUTATAN',
    },
    {
        CITY: 'MUNTINLUPA',
        BARANGAY: 'PUTATAN',
    },
    {
        CITY: 'MUNTINLUPA',
        BARANGAY: 'PUTATAN',
    },
    {
        CITY: 'MUNTINLUPA',
        BARANGAY: 'SUCAT',
    },
    {
        CITY: 'MUNTINLUPA',
        BARANGAY: 'SUCAT',
    },
    {
        CITY: 'MUNTINLUPA',
        BARANGAY: 'TUNASAN',
    },
    {
        CITY: 'NAVOTAS',
        BARANGAY: 'BAGUMBAYAN NORTH',
    },
    {
        CITY: 'NAVOTAS',
        BARANGAY: 'BAGUMBAYAN SOUTH',
    },
    {
        CITY: 'NAVOTAS',
        BARANGAY: 'BANGCULASI',
    },
    {
        CITY: 'NAVOTAS',
        BARANGAY: 'DAANGHARI',
    },
    {
        CITY: 'NAVOTAS',
        BARANGAY: 'NAVOTAS EAST',
    },
    {
        CITY: 'NAVOTAS',
        BARANGAY: 'NAVOTAS WEST',
    },
    {
        CITY: 'NAVOTAS',
        BARANGAY: 'NBBS DAGAT-DAGATAN (NORTH BAY BOULEVARD SOUTH)',
    },
    {
        CITY: 'NAVOTAS',
        BARANGAY: 'NBBS KAUNLARAN (NORTH BAY BOULEVARD SOUTH)',
    },
    {
        CITY: 'NAVOTAS',
        BARANGAY: 'NBBS PROPER (NORTH BAY BOULEVARD SOUTH)',
    },
    {
        CITY: 'NAVOTAS',
        BARANGAY: 'NORTH BAY BLVD.',
    },
    {
        CITY: 'NAVOTAS',
        BARANGAY: 'NORTH BAY BOULEVARD NORTH',
    },
    {
        CITY: 'NAVOTAS',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'NAVOTAS',
        BARANGAY: 'SAN JOSE (POB.)',
    },
    {
        CITY: 'NAVOTAS',
        BARANGAY: 'SAN RAFAEL VILLAGE',
    },
    {
        CITY: 'NAVOTAS',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'NAVOTAS',
        BARANGAY: 'SIPAC-ALMACEN',
    },
    {
        CITY: 'NAVOTAS',
        BARANGAY: 'TANGOS',
    },
    {
        CITY: 'NAVOTAS',
        BARANGAY: 'TANGOS NORTH (TANGOS)',
    },
    {
        CITY: 'NAVOTAS',
        BARANGAY: 'TANGOS SOUTH (TANGOS)',
    },
    {
        CITY: 'NAVOTAS',
        BARANGAY: 'TANZA',
    },
    {
        CITY: 'NAVOTAS',
        BARANGAY: 'TANZA 1 (TANZA)',
    },
    {
        CITY: 'NAVOTAS',
        BARANGAY: 'TANZA 2 (TANZA)',
    },
    {
        CITY: 'NORTH-CALOOCAN',
        BARANGAY: 'BARANGAY 165',
    },
    {
        CITY: 'NORTH-CALOOCAN',
        BARANGAY: 'BARANGAY 166',
    },
    {
        CITY: 'NORTH-CALOOCAN',
        BARANGAY: 'BARANGAY 167',
    },
    {
        CITY: 'NORTH-CALOOCAN',
        BARANGAY: 'BARANGAY 168',
    },
    {
        CITY: 'NORTH-CALOOCAN',
        BARANGAY: 'BARANGAY 169',
    },
    {
        CITY: 'NORTH-CALOOCAN',
        BARANGAY: 'BARANGAY 170',
    },
    {
        CITY: 'NORTH-CALOOCAN',
        BARANGAY: 'BARANGAY 171',
    },
    {
        CITY: 'NORTH-CALOOCAN',
        BARANGAY: 'BARANGAY 172',
    },
    {
        CITY: 'NORTH-CALOOCAN',
        BARANGAY: 'BARANGAY 173',
    },
    {
        CITY: 'NORTH-CALOOCAN',
        BARANGAY: 'BARANGAY 174',
    },
    {
        CITY: 'NORTH-CALOOCAN',
        BARANGAY: 'BARANGAY 175',
    },
    {
        CITY: 'NORTH-CALOOCAN',
        BARANGAY: 'BARANGAY 176',
    },
    {
        CITY: 'NORTH-CALOOCAN',
        BARANGAY: 'BARANGAY 176',
    },
    {
        CITY: 'NORTH-CALOOCAN',
        BARANGAY: 'BARANGAY 177',
    },
    {
        CITY: 'NORTH-CALOOCAN',
        BARANGAY: 'BARANGAY 178',
    },
    {
        CITY: 'NORTH-CALOOCAN',
        BARANGAY: 'BARANGAY 179',
    },
    {
        CITY: 'NORTH-CALOOCAN',
        BARANGAY: 'BARANGAY 180',
    },
    {
        CITY: 'NORTH-CALOOCAN',
        BARANGAY: 'BARANGAY 181',
    },
    {
        CITY: 'NORTH-CALOOCAN',
        BARANGAY: 'BARANGAY 182',
    },
    {
        CITY: 'NORTH-CALOOCAN',
        BARANGAY: 'BARANGAY 183',
    },
    {
        CITY: 'NORTH-CALOOCAN',
        BARANGAY: 'BARANGAY 184',
    },
    {
        CITY: 'NORTH-CALOOCAN',
        BARANGAY: 'BARANGAY 185',
    },
    {
        CITY: 'NORTH-CALOOCAN',
        BARANGAY: 'BARANGAY 186',
    },
    {
        CITY: 'NORTH-CALOOCAN',
        BARANGAY: 'BARANGAY 187',
    },
    {
        CITY: 'NORTH-CALOOCAN',
        BARANGAY: 'BARANGAY 188',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 662',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 664~A',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 664-A',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 671',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 672',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 673',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 674',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 675',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 676',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 677',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 678',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 679',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 680',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 681',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 682',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 683',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 684',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 685',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 686',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 687',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 687',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 809',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 810',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 811',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 812',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 813',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 814',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 815',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 816',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 817',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 818',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 819',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 820',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 821',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 822',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 823',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 824',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 825',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 826',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 827',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 828',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 829',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 830',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 831',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 831',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 832',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 833',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 834',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 835',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 836',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 837',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 838',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 839',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 839',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 840',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 841',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 842',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 843',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 844',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 845',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 846',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 847',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 848',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 849',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 850',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 851',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 852',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 853',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 855',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 856',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 857',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 858',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 859',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 860',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 861',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 862',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 863',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 864',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 865',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 867',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 868',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 869',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 870',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 871',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 872',
    },
    {
        CITY: 'PARANAQUE',
        BARANGAY: 'B. F. HOMES',
    },
    {
        CITY: 'PARANAQUE',
        BARANGAY: 'BACLARAN',
    },
    {
        CITY: 'PARANAQUE',
        BARANGAY: 'DON BOSCO',
    },
    {
        CITY: 'PARANAQUE',
        BARANGAY: 'DON BOSCO',
    },
    {
        CITY: 'PARANAQUE',
        BARANGAY: 'DON GALO',
    },
    {
        CITY: 'PARANAQUE',
        BARANGAY: 'LA HUERTA',
    },
    {
        CITY: 'PARANAQUE',
        BARANGAY: 'MARCELO GREEN VILLAGE',
    },
    {
        CITY: 'PARANAQUE',
        BARANGAY: 'MERVILLE',
    },
    {
        CITY: 'PARANAQUE',
        BARANGAY: 'MOONWALK',
    },
    {
        CITY: 'PARANAQUE',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'PARANAQUE',
        BARANGAY: 'SAN DIONISIO',
    },
    {
        CITY: 'PARANAQUE',
        BARANGAY: 'SAN DIONISIO',
    },
    {
        CITY: 'PARANAQUE',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'PARANAQUE',
        BARANGAY: 'SAN MARTIN DE PORRES',
    },
    {
        CITY: 'PARANAQUE',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'PARANAQUE',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'PARANAQUE',
        BARANGAY: 'SUN VALLEY',
    },
    {
        CITY: 'PARANAQUE',
        BARANGAY: 'TAMBO',
    },
    {
        CITY: 'PARANAQUE',
        BARANGAY: 'TAMBO',
    },
    {
        CITY: 'PARANAQUE',
        BARANGAY: 'VITALEZ',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 1',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 10',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 100',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 101',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 102',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 103',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 104',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 105',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 106',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 107',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 108',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 109',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 11',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 110',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 111',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 112',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 113',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 114',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 115',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 116',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 116',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 117',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 118',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 119',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 12',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 120',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 121',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 122',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 123',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 124',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 125',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 126',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 127',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 128',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 129',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 13',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 130',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 131',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 132',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 133',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 134',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 135',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 136',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 137',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 138',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 139',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 14',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 140',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 141',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 142',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 143',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 144',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 145',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 146',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 147',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 148',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 149',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 15',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 150',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 151',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 152',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 153',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 154',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 155',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 156',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 157',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 158',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 159',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 16',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 160',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 161',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 162',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 163',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 164',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 165',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 166',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 167',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 168',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 169',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 17',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 170',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 171',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 172',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 173',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 174',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 175',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 176',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 177',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 178',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 179',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 18',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 180',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 181',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 182',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 183',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 184',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 185',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 186',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 187',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 188',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 189',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 19',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 190',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 191',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 192',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 193',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 194',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 195',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 196',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 197',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 198',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 199',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 2',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 20',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 200',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 201',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 21',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 22',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 23',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 24',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 25',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 26',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 27',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 28',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 29',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 3',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 30',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 31',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 32',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 33',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 34',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 35',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 36',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 37',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 38',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 39',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 4',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 40',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 41',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 42',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 43',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 44',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 45',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 46',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 47',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 48',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 49',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 5',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 50',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 51',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 52',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 53',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 54',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 55',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 56',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 57',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 58',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 59',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 6',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 60',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 61',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 62',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 63',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 64',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 65',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 66',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 67',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 68',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 69',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 7',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 70',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 71',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 72',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 73',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 74',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 75',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 76',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 77',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 78',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 79',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 8',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 80',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 81',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 81',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 82',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 83',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 84',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 85',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 86',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 87',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 88',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 89',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 9',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 90',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 91',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 92',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 93',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 94',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 95',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 96',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 97',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 98',
    },
    {
        CITY: 'PASAY',
        BARANGAY: 'BARANGAY 99',
    },
    {
        CITY: 'PASIG',
        BARANGAY: 'BAGONG ILOG',
    },
    {
        CITY: 'PASIG',
        BARANGAY: 'BAGONG ILOG',
    },
    {
        CITY: 'PASIG',
        BARANGAY: 'BAGONG KATIPUNAN',
    },
    {
        CITY: 'PASIG',
        BARANGAY: 'BAMBANG',
    },
    {
        CITY: 'PASIG',
        BARANGAY: 'BUTING',
    },
    {
        CITY: 'PASIG',
        BARANGAY: 'CANIOGAN',
    },
    {
        CITY: 'PASIG',
        BARANGAY: 'DELA PAZ',
    },
    {
        CITY: 'PASIG',
        BARANGAY: 'KALAWAAN',
    },
    {
        CITY: 'PASIG',
        BARANGAY: 'KAPASIGAN',
    },
    {
        CITY: 'PASIG',
        BARANGAY: 'KAPITOLYO',
    },
    {
        CITY: 'PASIG',
        BARANGAY: 'MALINAO',
    },
    {
        CITY: 'PASIG',
        BARANGAY: 'MANGGAHAN',
    },
    {
        CITY: 'PASIG',
        BARANGAY: 'MAYBUNGA',
    },
    {
        CITY: 'PASIG',
        BARANGAY: 'ORANBO',
    },
    {
        CITY: 'PASIG',
        BARANGAY: 'PALATIW',
    },
    {
        CITY: 'PASIG',
        BARANGAY: 'PINAGBUHATAN',
    },
    {
        CITY: 'PASIG',
        BARANGAY: 'PINAGBUHATAN',
    },
    {
        CITY: 'PASIG',
        BARANGAY: 'PINEDA',
    },
    {
        CITY: 'PASIG',
        BARANGAY: 'ROSARIO',
    },
    {
        CITY: 'PASIG',
        BARANGAY: 'SAGAD',
    },
    {
        CITY: 'PASIG',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'PASIG',
        BARANGAY: 'SAN JOAQUIN',
    },
    {
        CITY: 'PASIG',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'PASIG',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'PASIG',
        BARANGAY: 'SAN NICOLAS',
    },
    {
        CITY: 'PASIG',
        BARANGAY: 'SAN NICOLAS (POB.)',
    },
    {
        CITY: 'PASIG',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'PASIG',
        BARANGAY: 'SANTA LUCIA',
    },
    {
        CITY: 'PASIG',
        BARANGAY: 'SANTA LUCIA',
    },
    {
        CITY: 'PASIG',
        BARANGAY: 'SANTA ROSA',
    },
    {
        CITY: 'PASIG',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'PASIG',
        BARANGAY: 'SANTOLAN',
    },
    {
        CITY: 'PASIG',
        BARANGAY: 'SUMILANG',
    },
    {
        CITY: 'PASIG',
        BARANGAY: 'UGONG',
    },
    {
        CITY: 'PATEROS',
        BARANGAY: 'AGUHO',
    },
    {
        CITY: 'PATEROS',
        BARANGAY: 'MAGTANGGOL',
    },
    {
        CITY: 'PATEROS',
        BARANGAY: 'MARTIRES DEL 96',
    },
    {
        CITY: 'PATEROS',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'PATEROS',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'PATEROS',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'PATEROS',
        BARANGAY: 'SANTA ANA',
    },
    {
        CITY: 'PATEROS',
        BARANGAY: 'SANTO ROSARIO~KANLURAN',
    },
    {
        CITY: 'PATEROS',
        BARANGAY: 'SANTO ROSARIO~SILANGAN',
    },
    {
        CITY: 'PATEROS',
        BARANGAY: 'SANTO ROSARIO-KANLURAN',
    },
    {
        CITY: 'PATEROS',
        BARANGAY: 'SANTO ROSARIO-SILANGAN',
    },
    {
        CITY: 'PATEROS',
        BARANGAY: 'TABACALERA',
    },
    {
        CITY: 'PORT-AREA',
        BARANGAY: 'BARANGAY 649',
    },
    {
        CITY: 'PORT-AREA',
        BARANGAY: 'BARANGAY 650',
    },
    {
        CITY: 'PORT-AREA',
        BARANGAY: 'BARANGAY 651',
    },
    {
        CITY: 'PORT-AREA',
        BARANGAY: 'BARANGAY 652',
    },
    {
        CITY: 'PORT-AREA',
        BARANGAY: 'BARANGAY 653',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'ALICIA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'AMIHAN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'APOLONIO SAMSON',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'AURORA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'Aurora',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'BAESA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'BAGBAG',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'BAGONG LIPUNAN NG CRAME',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'BAGONG PAG~ASA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'BAGONG PAG-ASA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'BAGONG SILANGAN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'BAGONG SILANGAN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'BAGUMBUHAY',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'BAHAY TORO',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'BALINGASA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'BALINTAWAK',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'BALONG BATO',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'BATASAN HILLS',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'BAYANIHAN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'BLUE RIDGE A',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'BLUE RIDGE B',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'BOTOCAN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'BUNGAD',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'CAMP AGUINALDO',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'CAPITOL HILLS/PARK',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'CAPRI',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'CENTRAL',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'CLARO',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'COMMONWEALTH',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'CUBAO',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'CULIAT',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'DAMAR',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'DAMAYAN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'DAMAYANG LAGI',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'DAMAYANG LAGI',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'DAMONG MALIIT',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'DEL MONTE',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'DILIMAN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'DIOQUINO ZOBEL',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'DON MANUEL',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'DON MANUEL',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'DONA AURORA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'DONA AURORA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'DONA FAUSTINA SUBD',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'DONA IMELDA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'DONA JOSEFA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'DUYAN~DUYAN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'DUYAN-DUYAN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'E. RODRIGUEZ',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'E. RODRIGUEZ',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'EAST KAMIAS',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'ESCOPA I',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'ESCOPA II',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'ESCOPA III',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'ESCOPA IV',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'FAIRVIEW',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'GREATER LAGRO',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'GULOD',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'HOLY SPIRIT',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'HORSESHOE',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'IMMACULATE CONCEPCION',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'IMMACULATE CONCEPCION',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'KALIGAYAHAN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'KALIGAYAHAN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'KALUSUGAN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'KAMUNING',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'KATIPUNAN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'KAUNLARAN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'KRISTONG HARI',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'KRUS NA LIGAS',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'LA LOMA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'LAGING HANDA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'LIBIS',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'LOURDES',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'LOURDES',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'LOYOLA HEIGHTS',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'MAHARLIKA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'MALAYA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'MANGGA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'MANRESA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'MARIANA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'MARIANA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'MARIBLO',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'MARILAG',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'MASAGANA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'MASAMBONG',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'MATANDANG BALARA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'MILAGROSA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'N.S. AMORANTO (GINTONG SILAHIS)',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'NAGKAISANG NAYON',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'NAYONG KANLURAN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'NEW ERA (CONSTITUTION HILLS)',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'NORTH FAIRVIEW',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'NOVALICHES',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'NOVALICHES',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'NOVALICHES PROPER',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'OBRERO',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'OLD CAPITOL SITE',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'PAANG BUNDOK',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'PAG-IBIG SA NAYON',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'PALIGSAHAN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'PALTOK',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'PANSOL',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'PARAISO',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'PASONG PUTIK PROPER',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'PASONG PUTIK PROPER (PASONG PUTIK)',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'PASONG TAMO',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'PASONG TAMO',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'PAYATAS',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'PHIL-AM',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'PINAGKAISAHAN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'PINYAHAN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'PROJECT 2',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'PROJECT 3',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'PROJECT 4',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'PROJECT 6',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'PROJECT 7',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'PROJECT 8',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'QUEZON CITY CPO',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'QUIRINO 2A',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'QUIRINO 2-A',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'QUIRINO 2B',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'QUIRINO 2-B',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'QUIRINO 2C',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'QUIRINO 2-C',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'QUIRINO 3A',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'QUIRINO 3-A',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'RAMON MAGSAYSAY',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'ROXAS',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SACRED HEART',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SAINT IGNATIUS',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SAINT PETER',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SAN BARTOLOME',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SAN ISIDRO LABRADOR',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SAN MARTIN DE PORRES',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SAN MARTIN DE PORRES',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SANGANDAAN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SANTA LUCIA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SANTA MONICA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SANTA MONICA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SANTA TERESITA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SANTO CRISTO',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SANTO DOMINGO (MATALAHIB)',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SANTO DOMINGO (MATALAHIB)',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SANTOL',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SANTOL',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SAUYO',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SIENNA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SIKATUNA VILLAGE',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SILANGAN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SOCORRO',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SOUTH TRIANGLE',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'ST.PETER',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'STO.CRISTO',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'TAGUMPAY',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'TALAMPAS',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'TALAYAN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'TALIPAPA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'TANDANG SORA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'TATALON',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'TATALON',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'TEACHERS VILLAGE EAST',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'TEACHERS VILLAGE WEST',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'U.P. CAMPUS',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'U.P. VILLAGE',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'UGONG NORTE',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'UNANG SIGAW',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'VALENCIA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'VASRA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'VASRA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'VETERANS VILLAGE',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'VILLA MARIA CLARA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'WEST KAMIAS',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'WEST TRIANGLE',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'WEST TRIANGLE',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'WHITE PLAINS',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 306',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 307',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 308',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 309',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 383',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 384',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 385',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 386',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 387',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 388',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 389',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 390',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 391',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 392',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 393',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 394',
    },
    {
        CITY: 'STA-CRUZ-SOUTH',
        BARANGAY: 'BARANGAY 297',
    },
    {
        CITY: 'STA-CRUZ-SOUTH',
        BARANGAY: 'BARANGAY 298',
    },
    {
        CITY: 'STA-CRUZ-SOUTH',
        BARANGAY: 'BARANGAY 299',
    },
    {
        CITY: 'STA-CRUZ-SOUTH',
        BARANGAY: 'BARANGAY 300',
    },
    {
        CITY: 'STA-CRUZ-SOUTH',
        BARANGAY: 'BARANGAY 301',
    },
    {
        CITY: 'STA-CRUZ-SOUTH',
        BARANGAY: 'BARANGAY 302',
    },
    {
        CITY: 'STA-CRUZ-SOUTH',
        BARANGAY: 'BARANGAY 303',
    },
    {
        CITY: 'STA-CRUZ-SOUTH',
        BARANGAY: 'BARANGAY 304',
    },
    {
        CITY: 'STA-CRUZ-SOUTH',
        BARANGAY: 'BARANGAY 305',
    },
    {
        CITY: 'STA-CRUZ-SOUTH',
        BARANGAY: 'BARANGAY 310',
    },
    {
        CITY: 'STA-CRUZ-SOUTH',
        BARANGAY: 'BARANGAY 311',
    },
    {
        CITY: 'STA-CRUZ-SOUTH',
        BARANGAY: 'BARANGAY 312',
    },
    {
        CITY: 'STA-CRUZ-SOUTH',
        BARANGAY: 'BARANGAY 313',
    },
    {
        CITY: 'STA-CRUZ-SOUTH',
        BARANGAY: 'BARANGAY 314',
    },
    {
        CITY: 'STA-CRUZ-SOUTH',
        BARANGAY: 'BARANGAY 315',
    },
    {
        CITY: 'STA-CRUZ-SOUTH',
        BARANGAY: 'BARANGAY 316',
    },
    {
        CITY: 'STA-CRUZ-SOUTH',
        BARANGAY: 'BARANGAY 317',
    },
    {
        CITY: 'STA-CRUZ-SOUTH',
        BARANGAY: 'BARANGAY 318',
    },
    {
        CITY: 'STA-CRUZ-SOUTH',
        BARANGAY: 'BARANGAY 319',
    },
    {
        CITY: 'STA-CRUZ-SOUTH',
        BARANGAY: 'BARANGAY 320',
    },
    {
        CITY: 'STA-CRUZ-SOUTH',
        BARANGAY: 'BARANGAY 321',
    },
    {
        CITY: 'STA-CRUZ-SOUTH',
        BARANGAY: 'BARANGAY 322',
    },
    {
        CITY: 'STA-CRUZ-SOUTH',
        BARANGAY: 'BARANGAY 323',
    },
    {
        CITY: 'STA-CRUZ-SOUTH',
        BARANGAY: 'BARANGAY 324',
    },
    {
        CITY: 'STA-CRUZ-SOUTH',
        BARANGAY: 'BARANGAY 325',
    },
    {
        CITY: 'STA-CRUZ-SOUTH',
        BARANGAY: 'BARANGAY 326',
    },
    {
        CITY: 'STA-CRUZ-SOUTH',
        BARANGAY: 'BARANGAY 326',
    },
    {
        CITY: 'STA-CRUZ-SOUTH',
        BARANGAY: 'BARANGAY 327',
    },
    {
        CITY: 'STA-CRUZ-SOUTH',
        BARANGAY: 'BARANGAY 328',
    },
    {
        CITY: 'STA-CRUZ-SOUTH',
        BARANGAY: 'BARANGAY 329',
    },
    {
        CITY: 'STA-CRUZ-SOUTH',
        BARANGAY: 'BARANGAY 330',
    },
    {
        CITY: 'STA-CRUZ-SOUTH',
        BARANGAY: 'BARANGAY 331',
    },
    {
        CITY: 'STA-CRUZ-SOUTH',
        BARANGAY: 'BARANGAY 332',
    },
    {
        CITY: 'STA-CRUZ-SOUTH',
        BARANGAY: 'BARANGAY 333',
    },
    {
        CITY: 'STA-CRUZ-SOUTH',
        BARANGAY: 'BARANGAY 334',
    },
    {
        CITY: 'STA-CRUZ-SOUTH',
        BARANGAY: 'BARANGAY 335',
    },
    {
        CITY: 'STA-CRUZ-SOUTH',
        BARANGAY: 'BARANGAY 336',
    },
    {
        CITY: 'STA-CRUZ-SOUTH',
        BARANGAY: 'BARANGAY 337',
    },
    {
        CITY: 'STA-CRUZ-SOUTH',
        BARANGAY: 'BARANGAY 338',
    },
    {
        CITY: 'STA-CRUZ-SOUTH',
        BARANGAY: 'BARANGAY 339',
    },
    {
        CITY: 'STA-CRUZ-SOUTH',
        BARANGAY: 'BARANGAY 340',
    },
    {
        CITY: 'STA-CRUZ-SOUTH',
        BARANGAY: 'BARANGAY 341',
    },
    {
        CITY: 'STA-CRUZ-SOUTH',
        BARANGAY: 'BARANGAY 342',
    },
    {
        CITY: 'STA-CRUZ-SOUTH',
        BARANGAY: 'BARANGAY 343',
    },
    {
        CITY: 'STA-CRUZ-SOUTH',
        BARANGAY: 'BARANGAY 344',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'BAMBANG',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'CALZADA',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'CENTRAL BICUTAN',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'CENTRAL SIGNAL VILLAGE',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'CENTRAL SIGNAL VILLAGE (SIGNAL VILLAGE)',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'FORT BONIFACIO',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'FORT BONIFACIO',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'HAGONOY',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'IBAYO~TIPAS',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'IBAYO-TIPAS',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'KATUPARAN',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'LIGID~TIPAS',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'LIGID-TIPAS',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'LOWER BICUTAN',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'MAHARLIKA VILLAGE',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'MAIN OFFICE',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'MMDC',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'MMDC-1',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'NAPINDAN',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'NEW LOWER BICUTAN',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'NEW LOWER BICUTAN',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'NORTH DAAN HARI',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'NORTH DAANG HARI',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'NORTH SIGNAL VILLAGE',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'PALINGON',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'PINAGSAMA',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'PINAGSAMA',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'SANTA ANA',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'SOUTH DAAN HARI',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'SOUTH DAANG HARI',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'SOUTH SIGNAL VILLAGE',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'TANYAG',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'TANYAG (BAGONG TANYAG)',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'TUKTUKAN',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'UPPER BICUTAN',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'USUSAN',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'USUSAN',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'WAWA',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'WAWA',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'WESTERN BICUTAN',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'WESTERN BICUTAN',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'WESTERN BICUTAN',
    },
    {
        CITY: 'TAGUIG',
        BARANGAY: 'WESTERN BICUTAN',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 1',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 10',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 100',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 101',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 102',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 103',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 104',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 105',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 106',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 107',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 108',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 109',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 11',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 110',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 111',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 112',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 116',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 117',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 118',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 119',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 12',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 120',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 121',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 122',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 123',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 124',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 125',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 126',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 127',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 128',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 128',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 129',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 13',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 130',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 131',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 132',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 133',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 133',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 134',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 135',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 136',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 137',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 138',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 139',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 14',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 140',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 141',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 142',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 143',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 144',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 145',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 146',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 147',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 148',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 149',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 15',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 150',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 151',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 152',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 153',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 154',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 155',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 156',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 157',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 158',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 159',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 16',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 160',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 161',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 162',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 163',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 164',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 165',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 166',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 167',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 168',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 169',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 17',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 170',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 171',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 172',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 173',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 174',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 175',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 176',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 177',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 178',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 179',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 18',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 180',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 181',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 182',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 183',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 184',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 185',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 186',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 186',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 187',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 188',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 189',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 19',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 190',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 191',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 192',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 193',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 194',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 195',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 196',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 197',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 198',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 199',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 2',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 20',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 200',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 201',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 202',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 202~A',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 202-A',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 203',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 204',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 205',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 206',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 207',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 208',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 209',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 209',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 210',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 211',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 212',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 213',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 214',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 215',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 216',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 217',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 218',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 219',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 220',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 221',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 222',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 223',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 224',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 225',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 226',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 227',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 228',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 229',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 230',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 231',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 232',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 233',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 234',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 235',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 236',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 237',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 238',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 239',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 240',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 241',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 242',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 243',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 244',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 245',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 246',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 247',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 248',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 249',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 25',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 250',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 251',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 252',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 253',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 254',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 255',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 256',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 257',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 258',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 259',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 26',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 260',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 261',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 262',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 263',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 264',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 265',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 266',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 267',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 28',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 29',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 3',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 30',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 31',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 32',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 33',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 34',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 35',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 36',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 37',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 38',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 39',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 4',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 41',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 42',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 43',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 44',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 45',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 46',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 47',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 48',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 49',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 5',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 50',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 51',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 51',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 51',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 52',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 53',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 54',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 55',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 56',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 57',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 58',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 59',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 6',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 60',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 61',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 62',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 63',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 64',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 65',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 66',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 67',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 68',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 69',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 7',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 70',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 71',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 72',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 73',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 74',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 75',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 76',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 77',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 78',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 79',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 8',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 80',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 81',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 82',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 83',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 84',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 85',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 86',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 87',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 88',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 89',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 9',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 90',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 91',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 92',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 93',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 94',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 95',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 96',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 97',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 98',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 99',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 100',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 101',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 102',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 103',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 104',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 105',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 106',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 107',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 108',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 109',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 124',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 125',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 126',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 127',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 128',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 129',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 130',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 131',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 132',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 133',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 134',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 135',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 136',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 137',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 138',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 139',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 140',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 141',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 142',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 143',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 144',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 145',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 146',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 147',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 148',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 149',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 150',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 151',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 152',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 153',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 154',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 155',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 156',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 157',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 158',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 159',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 160',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 161',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 162',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 163',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 164',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 165',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 166',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 167',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 168',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 169',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 170',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 171',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 172',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 173',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 174',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 175',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 176',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 177',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 178',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 179',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 180',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 181',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 182',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 183',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 184',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 185',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 186',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 187',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 188',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 189',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 190',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 191',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 192',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 193',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 194',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 195',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 196',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 197',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 198',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 199',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 200',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 201',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 202',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 202-A',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 203',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 204',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 205',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 206',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 207',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 208',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 209',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 210',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 211',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 212',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 213',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 214',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 215',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 216',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 217',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 218',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 219',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 220',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 221',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 222',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 223',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 224',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 225',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 226',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 227',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 228',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 229',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 230',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 231',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 232',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 233',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 91',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 92',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 93',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 94',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 95',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 96',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 97',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 98',
    },
    {
        CITY: 'MANILA',
        BARANGAY: 'BARANGAY 99',
    },
    {
        CITY: 'VALENZUELA',
        BARANGAY: 'ARKONG BATO',
    },
    {
        CITY: 'VALENZUELA',
        BARANGAY: 'BAGBAGUIN',
    },
    {
        CITY: 'VALENZUELA',
        BARANGAY: 'BALANGKAS',
    },
    {
        CITY: 'VALENZUELA',
        BARANGAY: 'BIGNAY',
    },
    {
        CITY: 'VALENZUELA',
        BARANGAY: 'BISIG',
    },
    {
        CITY: 'VALENZUELA',
        BARANGAY: 'CANUMAY EAST',
    },
    {
        CITY: 'VALENZUELA',
        BARANGAY: 'CANUMAY EAST (CANUMAY)',
    },
    {
        CITY: 'VALENZUELA',
        BARANGAY: 'CANUMAY WEST',
    },
    {
        CITY: 'VALENZUELA',
        BARANGAY: 'CANUMAY WEST (CANUMAY)',
    },
    {
        CITY: 'VALENZUELA',
        BARANGAY: 'COLOONG',
    },
    {
        CITY: 'VALENZUELA',
        BARANGAY: 'DALANDANAN',
    },
    {
        CITY: 'VALENZUELA',
        BARANGAY: 'GEN. T. DE LEON',
    },
    {
        CITY: 'VALENZUELA',
        BARANGAY: 'HEN. T. DE LEON',
    },
    {
        CITY: 'VALENZUELA',
        BARANGAY: 'ISLA',
    },
    {
        CITY: 'VALENZUELA',
        BARANGAY: 'KARUHATAN',
    },
    {
        CITY: 'VALENZUELA',
        BARANGAY: 'LAWANG BATO',
    },
    {
        CITY: 'VALENZUELA',
        BARANGAY: 'LINGUNAN',
    },
    {
        CITY: 'VALENZUELA',
        BARANGAY: 'MABOLO',
    },
    {
        CITY: 'VALENZUELA',
        BARANGAY: 'MALANDAY',
    },
    {
        CITY: 'VALENZUELA',
        BARANGAY: 'MALINTA',
    },
    {
        CITY: 'VALENZUELA',
        BARANGAY: 'MAPULANG LUPA',
    },
    {
        CITY: 'VALENZUELA',
        BARANGAY: 'MARULAS',
    },
    {
        CITY: 'VALENZUELA',
        BARANGAY: 'MAYSAN',
    },
    {
        CITY: 'VALENZUELA',
        BARANGAY: 'PALASAN',
    },
    {
        CITY: 'VALENZUELA',
        BARANGAY: 'PARADA',
    },
    {
        CITY: 'VALENZUELA',
        BARANGAY: 'PARIANCILLO VILLA',
    },
    {
        CITY: 'VALENZUELA',
        BARANGAY: 'PASO DE BLAS',
    },
    {
        CITY: 'VALENZUELA',
        BARANGAY: 'PASOLO',
    },
    {
        CITY: 'VALENZUELA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'VALENZUELA',
        BARANGAY: 'PULO',
    },
    {
        CITY: 'VALENZUELA',
        BARANGAY: 'PUNTURIN',
    },
    {
        CITY: 'VALENZUELA',
        BARANGAY: 'RINCON',
    },
    {
        CITY: 'VALENZUELA',
        BARANGAY: 'TAGALAG',
    },
    {
        CITY: 'VALENZUELA',
        BARANGAY: 'UGONG',
    },
    {
        CITY: 'VALENZUELA',
        BARANGAY: 'VIENTE REALES',
    },
    {
        CITY: 'VALENZUELA',
        BARANGAY: 'WAWANG PULO',
    }
];
